import styled from 'styled-components';

export const LegalsViewWrapper = styled.div`
  margin-top: 30px;
  margin-bottom: 50px;
  h2, h3, a {
    color: ${props => `${props.theme.color.primaryColor}`};
  }
`;
